import React, { Component } from 'react';
import ErrorFallback from './ErrorFallback';
import { logClientError } from './logger';

class GlobalErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.handleRetry = this.handleRetry.bind(this);
    this.handleGoHome = this.handleGoHome.bind(this);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    logClientError(error, {
      source: 'GlobalErrorBoundary',
      componentStack: info?.componentStack || '',
    });
  }

  handleRetry() {
    this.setState({ hasError: false });
  }

  handleGoHome() {
    if (typeof window === 'undefined' || !window.location) return;
    window.location.assign('/');
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorFallback
          onRetry={this.handleRetry}
          onGoHome={this.handleGoHome}
        />
      );
    }

    return this.props.children;
  }
}

export default GlobalErrorBoundary;
